
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-black via-[#050a14] to-[#0a1628]">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgzMCwgNTgsIDEzOCwgMC4xKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-40"></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/70"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="text-center max-w-5xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-8 leading-tight">
            Professional Web Solutions and Automation Services for Businesses
          </h1>
          <p className="text-xl md:text-2xl lg:text-3xl text-white/70 mb-12 font-light leading-relaxed max-w-4xl mx-auto">
            Custom websites and AI automations that help businesses get more leads, save time, and scale faster.
          </p>
          <a href="https://calendly.com/nexoracorp/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] hover:bg-[#0d1e38] border border-[#1e3a8a]/50 text-white px-10 py-5 rounded-xl text-lg font-semibold transition-all duration-300 hover:shadow-2xl hover:shadow-[#1e3a8a]/30 hover:scale-105 whitespace-nowrap cursor-pointer">
            Book a Demo
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 bg-[#0a1628]/80 backdrop-blur-sm border border-[#1e3a8a]/30 px-6 py-3 rounded-lg">
        <p className="text-sm text-white/60">Remote Services | United States</p>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent"></div>
    </section>
  );
}
